<template>
  <Loader :loading="httpSend">
    <div v-if="!sync">
      <div class="row mt-3">
        <div class="col-sm-12">
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
            <i class="mdi mdi-alert-outline mr-2"></i>
            Ainda não foi realizada apuração para o período informado
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
          v-if="apuracoes.tipo1 && !apuracoes.tipo1.divergencia && !apuracoes.tipo2.divergencia && !apuracoes.tipo3.divergencia && !apuracoes.tipo4.divergencia && !apuracoes.tipo92.divergencia && !apuracoes.tipo94.divergencia && !apuracoes.tipo95.divergencia"
          class="row mt-1">
        <div class="col-sm-12">
          <b-card no-body class="mt-3 mb-1 border border-success shadow-none">
            <b-card-header class="bg-success" header-tag="header">
              <h6 class="m-0 text-white">
                Contribuinte sem divergências nesta competência
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                No momento não foram localizadas divergências para o contribuinte nesta competência.
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-sm-7">
          <b-card v-if="apuracoes.tipo1 && apuracoes.tipo1.divergencia" no-body
                  class="mt-3 mb-1 border border-danger shadow-none">
            <b-card-header class="bg-danger" header-tag="header">
              <h6 class="m-0 text-white">
                Base de Cálculo DAS-D ISS Próprio diferente NFS-e (Nat. Op. No Mun.)
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <h3>Critérios para a geração da divergência</h3>
                <ol class="pl-3 text-justify">
                  <li>O contribuinte deve pertencer ao regime de competência no Simples Nacional.</li>
                  <li>Deve existir no DAS-D valores de base de cálculo de ISS Próprio devido no município.</li>
                  <li>Deve(m) existir NFS-e emitidas sem retenção cujo local de exigibilidade do imposto seja no
                    município.
                  </li>
                  <li>A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base de
                    cálculo constante nas NFS-e emitidas.
                  </li>
                </ol>
                <div class="mt-4 alert alert-warning text-dark"><h3 class="mb-3">Valores utilizados na análise</h3>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Base de cálculo NFS-e
                      </td>
                      <td class="font-weight-bold h5">{{ apuracoes.tipo1.esr_base_nfs | formatNumeroBr }}
                      </td>
                    </tr>
                    <tr>
                      <td>Base de cálculo DAS-D
                      </td>
                      <td class="font-weight-bold h5">{{
                          apuracoes.tipo1.esr_base_das | formatNumeroBr
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4 alert alert-danger text-dark" role="alert"><h3>Como regularizar esta divergência?</h3>
                  <p>Para resolver a divergência de “Base de Cálculo DAS-D referente ao ISS Próprio diferente NFS-e
                    (Nat. Op. No Mun.)”, é necessário realizar a retificação no DAS-D do valor da base de cálculo
                    declarado na atividade de Prestação de serviços sem retenção/substituição com o ISS devido no
                    Município referente ao mês de competência identificado na divergência.</p>
                  <p>Se o valor da base de cálculo constante no DAS-D estiver correto, deverá ser analisado o somatório
                    da base cálculo das notas fiscais de serviços de ISS Próprio do mês de competência identificado na
                    divergência e realizar, se for o caso, a emissão, cancelamento ou substituição da NFS-e observando a
                    legislação do município para estes procedimentos, para que o total da base de cálculo de ISS Próprio
                    das notas fiscais geradas sejam o mesmo constante no DAS-D.</p></div>
              </b-card-text>
            </b-card-body>
          </b-card>
          <b-card v-if="apuracoes.tipo2 && apuracoes.tipo2.divergencia" no-body
                  class="mt-3 mb-1 border border-danger shadow-none">
            <b-card-header class="bg-danger" header-tag="header">
              <h6 class="m-0 text-white">
                Base de Cálculo DAS-D diferente da NFS-e (Outros Municípios)
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <p>Avaliação da consistência entre os valores declarados na base de cálculo do DAS-D e o valor das bases
                  de cálculos das notas emitidas no período da apuração.</p>
                <h3 class="mt-4">Critérios para a geração da divergência</h3>
                <ol class="pl-3">
                  <li>O contribuinte deve pertencer ao regime de competência no Simples Nacional.</li>
                  <li>Deve existir no DAS-D valores de base de cálculo de ISS Próprio devido no município.</li>
                  <li>Deve(m) existir NFS-e emitidas sem retenção cujo local de exigibilidade do imposto seja no
                    município.
                  </li>
                  <li>A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base de
                    cálculo constante nas NFS-e emitidas.
                  </li>
                </ol>
                <div class="mt-4 alert alert-warning text-dark"><h3 class="mb-3">Valores utilizados na análise</h3>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Base de cálculo NFS-e
                      </td>
                      <td class="font-weight-bold h5">{{ apuracoes.tipo2.esr_base_nfs | formatNumeroBr }}
                      </td>
                    </tr>
                    <tr>
                      <td>Base de cálculo DAS-D
                      </td>
                      <td class="font-weight-bold h5">{{
                          apuracoes.tipo2.esr_base_das | formatNumeroBr
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4 alert alert-danger text-dark" role="alert"><h3>Como regularizar esta divergência?</h3>
                  <p>Para resolver a divergência de “Base de Cálculo DAS-D referente ao ISS Próprio diferente NFS-e
                    (Nat. Op. No Mun.)”, é necessário realizar a retificação no DAS-D do valor da base de cálculo
                    declarado na atividade de Prestação de serviços sem retenção/substituição com o ISS devido no
                    Município referente ao mês de competência identificado na divergência.</p>
                  <p>Se o valor da base de cálculo constante no DAS-D estiver correto, deverá ser analisado o somatório
                    da base cálculo das notas fiscais de serviços de ISS Próprio do mês de competência identificado na
                    divergência e realizar, se for o caso, a emissão, cancelamento ou substituição da NFS-e observando a
                    legislação do município para estes procedimentos, para que o total da base de cálculo de ISS Próprio
                    das notas fiscais geradas sejam o mesmo constante no DAS-D.</p></div>
              </b-card-text>
            </b-card-body>
          </b-card>
          <b-card v-if="apuracoes.tipo3 && apuracoes.tipo3.divergencia" no-body
                  class="mt-3 mb-1 border border-danger shadow-none">
            <b-card-header class="bg-danger" header-tag="header">
              <h6 class="m-0 text-white">Base de Cálculo DAS-D diferente da NFS-e (ISS Retido)</h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <p>Avaliação da consistência entre os valores declarados na base de cálculo do DAS-D e o valor das bases
                  de cálculos das notas emitidas no período da apuração.</p>
                <h3 class="mt-4">Critérios para a geração da divergência</h3>
                <ol class="pl-3">
                  <li>O contribuinte deve pertencer ao regime de competência no Simples Nacional.</li>
                  <li>Deve existir no DAS-D valores de base de cálculo de ISS Próprio devido no município.</li>
                  <li>Deve(m) existir NFS-e emitidas sem retenção cujo local de exigibilidade do imposto seja no
                    município.
                  </li>
                  <li>A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base de
                    cálculo constante nas NFS-e emitidas.
                  </li>
                </ol>
                <div class="mt-4 alert alert-warning text-dark"><h3 class="mb-3">Valores utilizados na análise</h3>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Base de cálculo NFS-e
                      </td>
                      <td class="font-weight-bold h5">{{ apuracoes.tipo3.esr_base_nfs | formatNumeroBr }}
                      </td>
                    </tr>
                    <tr>
                      <td>Base de cálculo DAS-D
                      </td>
                      <td class="font-weight-bold h5">{{
                          apuracoes.tipo3.esr_base_das | formatNumeroBr
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4 alert alert-danger text-dark" role="alert"><h3>Como regularizar esta divergência?</h3>
                  <p>Para resolver a divergência de “Base de Cálculo DAS-D referente ao ISS Próprio diferente NFS-e
                    (Nat. Op. No Mun.)”, é necessário realizar a retificação no DAS-D do valor da base de cálculo
                    declarado na atividade de Prestação de serviços sem retenção/substituição com o ISS devido no
                    Município referente ao mês de competência identificado na divergência.</p>
                  <p>Se o valor da base de cálculo constante no DAS-D estiver correto, deverá ser analisado o somatório
                    da base cálculo das notas fiscais de serviços de ISS Próprio do mês de competência identificado na
                    divergência e realizar, se for o caso, a emissão, cancelamento ou substituição da NFS-e observando a
                    legislação do município para estes procedimentos, para que o total da base de cálculo de ISS Próprio
                    das notas fiscais geradas sejam o mesmo constante no DAS-D.</p></div>
              </b-card-text>
            </b-card-body>
          </b-card>
          <b-card v-if="apuracoes.tipo4 && apuracoes.tipo4.divergencia" no-body
                  class="mt-3 mb-1 border border-danger shadow-none">
            <b-card-header class="bg-danger" header-tag="header">
              <h6 class="m-0 text-white">
                Base de Cálculo DAS-D diferente da NFS-e (Não sujeito a ISS sobre o faturamento)
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <p>Avaliação da consistência entre os valores declarados na base de cálculo do DAS-D e o valor das bases
                  de cálculos das notas emitidas no período da apuração.</p>
                <h3 class="mt-4">Critérios para a geração da divergência</h3>
                <ol class="pl-3">
                  <li>O contribuinte deve pertencer ao regime de competência no Simples Nacional.</li>
                  <li>Deve existir no DAS-D valores de base de cálculo de ISS Próprio devido no município.</li>
                  <li>Deve(m) existir NFS-e emitidas sem retenção cujo local de exigibilidade do imposto seja no
                    município.
                  </li>
                  <li>A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base de
                    cálculo constante nas NFS-e emitidas.
                  </li>
                </ol>
                <div class="mt-4 alert alert-warning text-dark"><h3 class="mb-3">Valores utilizados na análise</h3>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Base de cálculo NFS-e
                      </td>
                      <td class="font-weight-bold h5">{{ apuracoes.tipo4.esr_base_nfs | formatNumeroBr }}
                      </td>
                    </tr>
                    <tr>
                      <td>Base de cálculo DAS-D
                      </td>
                      <td class="font-weight-bold h5">{{
                          apuracoes.tipo4.esr_base_das | formatNumeroBr
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4 alert alert-danger text-dark" role="alert"><h3>Como regularizar esta divergência?</h3>
                  <p>Para resolver a divergência de “Base de Cálculo DAS-D referente ao ISS Próprio diferente NFS-e
                    (Nat. Op. No Mun.)”, é necessário realizar a retificação no DAS-D do valor da base de cálculo
                    declarado na atividade de Prestação de serviços sem retenção/substituição com o ISS devido no
                    Município referente ao mês de competência identificado na divergência.</p>
                  <p>Se o valor da base de cálculo constante no DAS-D estiver correto, deverá ser analisado o somatório
                    da base cálculo das notas fiscais de serviços de ISS Próprio do mês de competência identificado na
                    divergência e realizar, se for o caso, a emissão, cancelamento ou substituição da NFS-e observando a
                    legislação do município para estes procedimentos, para que o total da base de cálculo de ISS Próprio
                    das notas fiscais geradas sejam o mesmo constante no DAS-D.</p></div>
              </b-card-text>
            </b-card-body>
          </b-card>
          <b-card v-if="apuracoes.tipo92 && apuracoes.tipo92.divergencia" no-body
                  class="mt-3 mb-1 border border-danger shadow-none">
            <b-card-header class="bg-danger" header-tag="header">
              <h6 class="m-0 text-white">
                Optantes sem DAS-D e com emissão de NFS-e
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <p>Avaliação da consistência entre os valores declarados na base de cálculo do DAS-D e o valor das bases
                  de cálculos das notas emitidas no período da apuração.</p>
                <h3 class="mt-4">Critérios para a geração da divergência</h3>
                <ol class="pl-3">
                  <li>O contribuinte deve pertencer ao regime de competência no Simples Nacional.</li>
                  <li>Deve existir no DAS-D valores de base de cálculo de ISS Próprio devido no município.</li>
                  <li>Deve(m) existir NFS-e emitidas sem retenção cujo local de exigibilidade do imposto seja no
                    município.
                  </li>
                  <li>A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base de
                    cálculo constante nas NFS-e emitidas.
                  </li>
                </ol>
                <div class="mt-4 alert alert-warning text-dark"><h3 class="mb-3">Valores utilizados na análise</h3>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Base de cálculo NFS-e
                      </td>
                      <td class="font-weight-bold h5">{{ apuracoes.tipo92.esr_base_nfs | formatNumeroBr }}
                      </td>
                    </tr>
                    <tr>
                      <td>Base de cálculo DAS-D
                      </td>
                      <td class="font-weight-bold h5">{{
                          apuracoes.tipo92.esr_base_das | formatNumeroBr
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4 alert alert-danger text-dark" role="alert"><h3>Como regularizar esta divergência?</h3>
                  <p>Para resolver a divergência de “Base de Cálculo DAS-D referente ao ISS Próprio diferente NFS-e
                    (Nat. Op. No Mun.)”, é necessário realizar a retificação no DAS-D do valor da base de cálculo
                    declarado na atividade de Prestação de serviços sem retenção/substituição com o ISS devido no
                    Município referente ao mês de competência identificado na divergência.</p>
                  <p>Se o valor da base de cálculo constante no DAS-D estiver correto, deverá ser analisado o somatório
                    da base cálculo das notas fiscais de serviços de ISS Próprio do mês de competência identificado na
                    divergência e realizar, se for o caso, a emissão, cancelamento ou substituição da NFS-e observando a
                    legislação do município para estes procedimentos, para que o total da base de cálculo de ISS Próprio
                    das notas fiscais geradas sejam o mesmo constante no DAS-D.</p></div>
              </b-card-text>
            </b-card-body>
          </b-card>
          <b-card v-if="apuracoes.tipo94 && apuracoes.tipo94.divergencia" no-body
                  class="mt-3 mb-1 border border-danger shadow-none">
            <b-card-header class="bg-danger" header-tag="header">
              <h6 class="m-0 text-white">
                Optantes com DAS-D e sem emissão de NFS-e
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <p>Avaliação da consistência entre os valores declarados na base de cálculo do DAS-D e o valor das bases
                  de cálculos das notas emitidas no período da apuração.</p>
                <h3 class="mt-4">Critérios para a geração da divergência</h3>
                <ol class="pl-3">
                  <li>O contribuinte deve pertencer ao regime de competência no Simples Nacional.</li>
                  <li>Deve existir no DAS-D valores de base de cálculo de ISS Próprio devido no município.</li>
                  <li>Deve(m) existir NFS-e emitidas sem retenção cujo local de exigibilidade do imposto seja no
                    município.
                  </li>
                  <li>A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base de
                    cálculo constante nas NFS-e emitidas.
                  </li>
                </ol>
                <div class="mt-4 alert alert-warning text-dark"><h3 class="mb-3">Valores utilizados na análise</h3>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Base de cálculo NFS-e
                      </td>
                      <td class="font-weight-bold h5">{{ apuracoes.tipo94.esr_base_nfs | formatNumeroBr }}
                      </td>
                    </tr>
                    <tr>
                      <td>Base de cálculo DAS-D
                      </td>
                      <td class="font-weight-bold h5">{{
                          apuracoes.tipo94.esr_base_das | formatNumeroBr
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4 alert alert-danger text-dark" role="alert"><h3>Como regularizar esta divergência?</h3>
                  <p>Para resolver a divergência de “Base de Cálculo DAS-D referente ao ISS Próprio diferente NFS-e
                    (Nat. Op. No Mun.)”, é necessário realizar a retificação no DAS-D do valor da base de cálculo
                    declarado na atividade de Prestação de serviços sem retenção/substituição com o ISS devido no
                    Município referente ao mês de competência identificado na divergência.</p>
                  <p>Se o valor da base de cálculo constante no DAS-D estiver correto, deverá ser analisado o somatório
                    da base cálculo das notas fiscais de serviços de ISS Próprio do mês de competência identificado na
                    divergência e realizar, se for o caso, a emissão, cancelamento ou substituição da NFS-e observando a
                    legislação do município para estes procedimentos, para que o total da base de cálculo de ISS Próprio
                    das notas fiscais geradas sejam o mesmo constante no DAS-D.</p></div>
              </b-card-text>
            </b-card-body>
          </b-card>
          <b-card v-if="apuracoes.tipo95 && apuracoes.tipo95.divergencia" no-body
                  class="mt-3 mb-1 border border-danger shadow-none">
            <b-card-header class="bg-danger" header-tag="header">
              <h6 class="m-0 text-white">
                Optantes com DAS-D e sem cadastro no NFS-e
              </h6>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <p>Avaliação da consistência entre os valores declarados na base de cálculo do DAS-D e o valor das bases
                  de cálculos das notas emitidas no período da apuração.</p>
                <h3 class="mt-4">Critérios para a geração da divergência</h3>
                <ol class="pl-3">
                  <li>O contribuinte deve pertencer ao regime de competência no Simples Nacional.</li>
                  <li>Deve existir no DAS-D valores de base de cálculo de ISS Próprio devido no município.</li>
                  <li>Deve(m) existir NFS-e emitidas sem retenção cujo local de exigibilidade do imposto seja no
                    município.
                  </li>
                  <li>A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base de
                    cálculo constante nas NFS-e emitidas.
                  </li>
                </ol>
                <div class="mt-4 alert alert-warning text-dark"><h3 class="mb-3">Valores utilizados na análise</h3>
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Base de cálculo NFS-e
                      </td>
                      <td class="font-weight-bold h5">{{ apuracoes.tipo95.esr_base_nfs | formatNumeroBr }}
                      </td>
                    </tr>
                    <tr>
                      <td>Base de cálculo DAS-D
                      </td>
                      <td class="font-weight-bold h5">{{
                          apuracoes.tipo95.esr_base_das | formatNumeroBr
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4 alert alert-danger text-dark" role="alert"><h3>Como regularizar esta divergência?</h3>
                  <p>Para resolver a divergência de “Base de Cálculo DAS-D referente ao ISS Próprio diferente NFS-e
                    (Nat. Op. No Mun.)”, é necessário realizar a retificação no DAS-D do valor da base de cálculo
                    declarado na atividade de Prestação de serviços sem retenção/substituição com o ISS devido no
                    Município referente ao mês de competência identificado na divergência.</p>
                  <p>Se o valor da base de cálculo constante no DAS-D estiver correto, deverá ser analisado o somatório
                    da base cálculo das notas fiscais de serviços de ISS Próprio do mês de competência identificado na
                    divergência e realizar, se for o caso, a emissão, cancelamento ou substituição da NFS-e observando a
                    legislação do município para estes procedimentos, para que o total da base de cálculo de ISS Próprio
                    das notas fiscais geradas sejam o mesmo constante no DAS-D.</p></div>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
        <div class="col-sm-5">
          <div v-if="apuracoes" class="card shadow-none">
            <div class="card-body"><h4 class="card-title mb-4">Análises Realizadas -
              {{ competencia.slice(4, 6) | monthNames }} de
              {{ competencia.slice(0, 4) }}</h4>
              <div>
                <ul class="verti-timeline list-unstyled">
                  <li class="event-list pb-1">
                    <div class="event-timeline-dot">
                      <i v-if="apuracoes.tipo1 && apuracoes.tipo1.divergencia"
                         class="text-danger bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                      <i v-else class="text-success bx bxs-check-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div><h5 class="font-size-13">Base de Cálculo DAS-D ISS Próprio diferente NFS-e (Nat. Op. No Mun.)</h5>
                          <p class="text-muted text-justify">
                            A divergência é gerada somente se a base de cálculo declarada no DAS-D for menor que a base
                            de
                            cálculo constante nas NFS-e emitidas sem retenção cujo local de exigibilidade do imposto
                            seja
                            no município.</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list pb-1">
                    <div class="event-timeline-dot">
                      <i v-if="apuracoes.tipo2 && apuracoes.tipo2.divergencia"
                         class="text-danger bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                      <i v-else class="text-success bx bxs-check-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div><h5 class="font-size-13">Base de Cálculo DAS-D diferente da NFS-e (Outros Municípios)</h5>
                          <p class="text-muted text-justify">
                            A divergência é gerada somente se a base de cálculo declarada no DAS-D for maior que a base
                            de
                            cálculo constante nas NFS-e emitidas com retenção cujo local de exigibilidade do imposto
                            seja
                            no município.</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list pb-1">
                    <div class="event-timeline-dot">
                      <i v-if="apuracoes.tipo3 && apuracoes.tipo3.divergencia"
                         class="text-danger bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                      <i v-else class="text-success bx bxs-check-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div><h5 class="font-size-13">Base de Cálculo DAS-D diferente da NFS-e (ISS Retido)</h5>
                          <p class="text-muted"> New common language will be more simple and regular than the
                            existing. </p></div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list pb-1">
                    <div class="event-timeline-dot">
                      <i v-if="apuracoes.tipo4 && apuracoes.tipo4.divergencia"
                         class="text-danger bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                      <i v-else class="text-success bx bxs-check-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div><h5 class="font-size-13">Base de Cálculo DAS-D diferente da NFS-e (Não sujeito a ISS sobre o faturamento)</h5>
                          <p class="text-muted"> New common language will be more simple and regular than the
                            existing. </p></div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list pb-1">
                    <div class="event-timeline-dot">
                      <i v-if="apuracoes.tipo92 && apuracoes.tipo92.divergencia"
                         class="text-danger bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                      <i v-else class="text-success bx bxs-check-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div><h5 class="font-size-13">Optantes sem DAS-D e com emissão de NFS-e</h5>
                          <p class="text-muted"> New common language will be more simple and regular than the
                            existing. </p></div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list pb-1">
                    <div class="event-timeline-dot">
                      <i v-if="apuracoes.tipo94 && apuracoes.tipo94.divergencia"
                         class="text-danger bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                      <i v-else class="text-success bx bxs-check-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div><h5 class="font-size-13">Optantes com DAS-D e sem emissão de NFS-e</h5>
                          <p class="text-muted"> New common language will be more simple and regular than the
                            existing. </p></div>
                      </div>
                    </div>
                  </li>
                  <li class="event-list pb-1">
                    <div class="event-timeline-dot">
                      <i v-if="apuracoes.tipo95 && apuracoes.tipo95.divergencia"
                         class="text-danger bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                      <i v-else class="text-success bx bxs-check-circle font-size-18"></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div><h5 class="font-size-13">Optantes com DAS-D e sem cadastro no NFS-e</h5>
                          <p class="text-muted"> New common language will be more simple and regular than the
                            existing. </p></div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>

<script>
import Loader from "../../../../../components/widgets/loader";
import {listApuracaoSimplesNacional} from "../../../../../api/simples_nacional/apuracao";

export default {
  name: "simplesApuracao",
  components: {
    Loader,
  },
  props: {
    eco_codigo: {
      type: String,
      required: true,
    },
    competencia: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      httpSend: false,
      sync: false,
      apuracoes: {}
    };
  },
  created() {
    this.list_apuracao()
  },
  methods: {
    list_apuracao() {
      this.httpSend = true;
      listApuracaoSimplesNacional(this.eco_codigo, this.competencia).then(result => {
        const dados = result.dados;
        this.sync = dados.sync;
        if (dados.sync) {
          this.apuracoes = dados.apuracao;
        } else {
          this.apuracoes = {}
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
}
</script>

<style scoped>

</style>
